import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {API_BASE_URL} from './env.service';
import {SupportToken} from '../../shared/models/support';
import {SessionService} from './session.service';

@Injectable({
  providedIn: 'root',
})
export class HelpService {


  constructor(
    private session: SessionService,
  ) {
  }


  private get widget(): CallableFunction {
    // @ts-ignore
    return window.FreshworksWidget;
  }


  showSupportTicketWidget$(st: SupportToken) {
    this.widget('prefill', 'ticketForm', {
      custom_fields: {
        cf_user_id: this.session.userId,
      },
    });
    this.widget('open');
    this.widget('authenticate', {
      token: st.JWT,
      callback: () => {
        fetch(`${API_BASE_URL}/support/token`).then((data) => {
          const supportToken = data as unknown as Response & SupportToken;
          this.widget('authenticate', {
            token: supportToken.JWT,
          });
        });
      },
    });
  }


  createHelpCenterToken$(returnToUrl?: string): Observable<SupportToken> {
    return new Observable<SupportToken>(
      subscriber => {
        this.session.http.get<SupportToken>(`${API_BASE_URL}/support/token`).subscribe(
          (st) => {
            subscriber.next(st);
            subscriber.complete();
          },
          (err) => {
            subscriber.error(err);
          },
        );
      },
    );
  }
}
